/**
 * RTCS-specific metric names.
 * These will be prefixed with "contactcenter_fe_" by the BFF.
 */
export const RTCSMetricNames = {
  RTCS_CONNECTION_TOTAL: 'rtcs_connection_total',
  RTCS_STATE_CHANGE_TOTAL: 'rtcs_state_change_total',
  CONNECTION_CORRELATION_TOTAL: 'connection_correlation_total',
  RTCS_EVENT_LATENCY_DURATION: 'rtcs_event_latency_duration',
} as const;

/**
 * RTCS-specific metric tags.
 */
export const RTCSMetricTags = {
  RTCS_STATUS: 'rtcs_status',
  RTCS_STATE_FROM: 'rtcs_state_from',
  RTCS_STATE_TO: 'rtcs_state_to',
  WEBPHONE_STATUS: 'webphone_status',
  STATUS: 'status',
  EVENT_TYPE: 'event_type',
} as const;

/**
 * RTCS connection state values.
 * Used with RTCSMetricTags.RTCS_STATUS for connection state tracking.
 */
export const RTCSStatus = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  RECONNECTING: 'reconnecting',
  FAILED: 'failed',
} as const;

/**
 * WebPhone registration status values.
 * Used with RTCSMetricTags.WEBPHONE_STATUS for correlation metrics.
 */
export const WebPhoneStatus = {
  REGISTERED: 'registered',
  UNREGISTERED: 'unregistered',
} as const;

/**
 * Connection status values for RTCS connection metrics.
 * Used with RTCSMetricTags.STATUS for RTCS_CONNECTION_TOTAL metric.
 */
export const ConnectionStatus = {
  ATTEMPTED: 'attempted',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const;

/**
 * Operation names for RTCS-related metrics.
 */
export const RTCSOperationNames = {
  RTCS_LOGIN: 'rtcs_login',
  RTCS_STATE_DURATION: 'rtcs_state_duration',
  RTCS_DISCONNECT_DURATION: 'rtcs_disconnect_duration',
} as const;

/**
 * RTCS event types for latency tracking.
 * Tracks time between server sending event and client receiving it.
 */
export const RTCSEventType = {
  SESSION_OFFERED: 'session_offered',
  SESSION_DELIVERED: 'session_delivered',
  SESSION_TERMINATED: 'session_terminated',
  SESSION_RESCINDED: 'session_rescinded',
  SESSION_REJECTED: 'session_rejected',
  AGENT_STATUS: 'agent_status',
  AGENT_READY: 'agent_ready',
  AGENT_AWAY: 'agent_away',
} as const;
